export default class constantService {
    static baseUrl = 'https://food-api.siefke.org';
}
